import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useAppRoutes } from '@root/features/routing'
import {
  ActionsList,
  ActionsListItem,
  CreateIcon,
  Drawer,
  ImportWalletIcon,
} from '@root/shared/ui-kit'
import { reatomWalletImportDialog } from '@root/widgets/wallet/wallet-import-drawer/atoms'

import { reatomAddWalletDrawerOpenedAtom } from './atoms'

export const AddWalletDrawer = () => {
  const { t } = useTranslation()

  const { navigateToNewWallet } = useAppRoutes()
  const [_, setIsOpenImportDialog] = useAtom(reatomWalletImportDialog)
  const [isOpen, setIsOpen] = useAtom(reatomAddWalletDrawerOpenedAtom)

  return (
    <Drawer
      open={isOpen}
      onOpenChange={setIsOpen}
      title={t('wallet.add_wallet')}
    >
      <Content>
        <ActionsList>
          <>
            <ActionsListItem
              variant="dark"
              label={t('wallet.create.create-new-wallet')}
              onClick={() => {
                setIsOpen(false)
                navigateToNewWallet()
              }}
              icon={CreateIcon}
              color="var(--primary-9)"
            />
            <ActionsListItem
              variant="dark"
              icon={ImportWalletIcon}
              label={t('wallet.import_wallet')}
              onClick={() => {
                setIsOpen(false)
                setIsOpenImportDialog(true)
              }}
              color="var(--primary-9)"
            />
          </>
        </ActionsList>
      </Content>
    </Drawer>
  )
}

const Content = styled.div`
  padding-inline: 8px;
  padding-block: 8px calc(8px + env(safe-area-inset-bottom));
`
